import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="bg-brand-lightBlue py-16 relative">
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
          alt="B2B Sales Team België"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue font-bold tracking-wider text-sm mb-4">CONSISTENCY WINS.</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
            Klaar voor voorspelbare groei?
          </h2>
          <p className="text-black text-lg mb-2">
            Eén partner, vijf functies. Een machine die werkt en waar je op kan vertrouwen.
          </p>
          <p className="text-black/80 mb-8">
            Geen intern SDR-team nodig. Wij regelen alles.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="bg-brand-red text-white px-6 py-3 rounded-md font-medium hover:bg-brand-red/90 transition-colors inline-flex items-center justify-center gap-2"
              onClick={handleClick}
            >
              Plan uw strategiegesprek
              <ArrowRight size={18} />
            </Link>
            <Link 
              to="/diensten" 
              className="border border-brand-red text-brand-red px-6 py-3 rounded-md font-medium hover:bg-brand-lightRed transition-colors inline-flex items-center justify-center"
              onClick={handleClick}
            >
              Bekijk hoe we werken
            </Link>
          </div>
          <p className="mt-6 text-black/70 text-sm font-medium">
            15 jaar ervaring • +500 projecten • 12 landen
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
